import './VisitFilter.scss'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import { MultiSelectDropdown, SecondaryButton, useLocalStorage, useOutsideClick } from 'ui_kit_qmd'
import { memo, useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import {
  CLEAR_TEXT,
  VISIT_FILTER_DROPDOWN_LABEL,
  VISITS_VISIT_FILTER_LOCAL_STORAGE_KEY,
} from '../../../../utils/constants'
import { useSessionStorage } from '../../../../utils/hooks/useSessionStorage'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const generateMultiSelectOptionsList = (serviceTypes) => {
  if (!serviceTypes.length) {
    return []
  }
  return (
    serviceTypes
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      .map((serviceType) =>
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        serviceType.VisitTypes.map((visitType) => ({
          value: `${serviceType.Name?.trim()} (${visitType.Name?.trim()})`,
          visitTypeId: visitType.VisitTypeId,
          isActive: false,
        })),
      )
      .flat()
  )
}
// @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
const VisitFilter = memo(({ onCloseFilterSettings, setFilterRow, loading, setVisitsListToShow, tableView }) => {
  const ref = useOutsideClick(onCloseFilterSettings)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const serviceTypes = useSelector((state) => state.accountSettings.serviceTypes)
  const [selectVisitTypeDropdownOptions, setSelectVisitTypeDropdownOptions] = useState([])
  const [storedSelectedVisitsList, setStoredSelectedVisitsList, removeStoredSelectedVisitsList] = useSessionStorage(
    VISITS_VISIT_FILTER_LOCAL_STORAGE_KEY,
    [],
  )

  useEffect(() => {
    setSelectVisitTypeDropdownOptions(
      storedSelectedVisitsList.length ? storedSelectedVisitsList : generateMultiSelectOptionsList(serviceTypes),
    )
  }, [])

  const onSetVisitTypeDropdownOptions = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (newOptions) => {
      setSelectVisitTypeDropdownOptions(newOptions)
      setStoredSelectedVisitsList(newOptions)
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      const selectedVisitTypeIdList = newOptions.filter((t) => t.isActive).map((item) => item.visitTypeId)
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      const apiRequestRow = selectedVisitTypeIdList.map((t, i) => `VisitTypeIds[${i}]=${t}`).join('&')
      setFilterRow(apiRequestRow)
    },
    [setFilterRow, setStoredSelectedVisitsList],
  )

  const onClearFilter = useCallback(() => {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    setSelectVisitTypeDropdownOptions((prev) => prev.map((t) => ({ ...t, isActive: false })))
    setFilterRow('')
    removeStoredSelectedVisitsList()
  }, [removeStoredSelectedVisitsList, setFilterRow])

  return (
    <div className='visits-page-visit-column-filter-container' ref={ref}>
      <MultiSelectDropdown
        isWithOptionsSort
        isDisabled={loading}
        isFlexible
        isEmptyMessage
        options={selectVisitTypeDropdownOptions}
        setOptions={onSetVisitTypeDropdownOptions}
        className='visits-page-table-filter-dropdown-select-visit-type'
        dropId='visits-page-table-filter-dropdown-select-visit-type-id'
        label={VISIT_FILTER_DROPDOWN_LABEL}
      />
      <SecondaryButton
        btnText={CLEAR_TEXT}
        onPress={onClearFilter}
        id='clear-visit-type-options-btn'
        className='clear-visit-type-options-btn-container'
      />
    </div>
  )
})

export default VisitFilter
